import React from 'react';

import { Card, Separator } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core/react/i18n';

import { EndorsementCardBodyContent } from './components/EndorsementCardBodyContent';
import { EndorsementCardHeader } from './components/EndorsementCardHeader';
import type { EndorsementCardEditProps } from './types';

export const EndorsementCardEdit: React.FC<EndorsementCardEditProps> = ({
	name,
	title,
	description,
	photoUrl,
	link,
	onEdit,
	onRemove,
	onReadMore,
	readMoreLabel,
	className,
	focusedField = null,
	displaySeparator = false,
}) => {
	const { translate } = useI18n();

	const namePlaceholder = translate('corgi.petition.starter_dashboard_v2.endorsements.add.preview_name_placeholder');
	const titlePlaceholder = translate('corgi.petition.starter_dashboard_v2.endorsements.add.preview_title_placeholder');
	const descriptionPlaceholder = translate(
		'corgi.petition.starter_dashboard_v2.endorsements.add.preview_description_placeholder',
	);

	const displayName = name || namePlaceholder;
	const displayTitle = title || titlePlaceholder;
	const displayDescription = description || descriptionPlaceholder;

	const isNamePlaceholder = !name;
	const isTitlePlaceholder = !title;
	const isDescriptionPlaceholder = !description;

	return (
		<Card className={cn('gap-0! p-6!', className || 'bg-fill-accent-primary-weaker border-none')}>
			<EndorsementCardHeader
				displayName={displayName}
				displayTitle={displayTitle}
				photoUrl={photoUrl}
				link={link}
				isNamePlaceholder={isNamePlaceholder}
				isTitlePlaceholder={isTitlePlaceholder}
				focusedField={focusedField}
				onEdit={onEdit}
				onRemove={onRemove}
			/>
			{displayDescription && (
				<>
					{displaySeparator && (
						<Separator orientation="horizontal" className="border-stroke-accent-primary-weak my-5 opacity-34" />
					)}

					<EndorsementCardBodyContent
						displayDescription={displayDescription}
						isDescriptionPlaceholder={isDescriptionPlaceholder}
						focusedField={focusedField}
						onReadMore={onReadMore}
						readMoreLabel={readMoreLabel}
					/>
				</>
			)}
		</Card>
	);
};
